import { InAppBrowserOptions } from "@awesome-cordova-plugins/in-app-browser";

export const CONFIG = {
  "CLOUD_STORAGE" : "CloudStorage",
  "DOMAIN" : "Domain",
  "EMAIL_OPTION" : "EmailOption",
  "FILE_OPTION" : "FileOption",
  "LOCK_LOCATION_CHANGE" : "LockLocationChange",
  "PICTURE_OPTION" : "PictureOption",
  "QR_SCANNING" : "QRScanning"
}

export const IN_APP_BROWSER_OPT: InAppBrowserOptions = {
  location: 'yes',
  clearcache: 'yes',
  clearsessioncache: 'yes',
  zoom: 'no', //Android only
  hardwareback: 'no',
  mediaPlaybackRequiresUserAction: 'no',
  shouldPauseOnSuspend: 'no', //Android only
  disallowoverscroll: 'no', //iOS only
  enableViewportScale: 'no', //iOS only
  allowInlineMediaPlayback: 'no', //iOS only
  hidenavigationbuttons: 'yes',
  hideurlbar: 'yes',
  fullscreen: 'yes',
  hidespinner: 'yes' 
};